import React, { useState } from "react";
import { Avatar, type SxProps, type Theme } from "@mui/material";

interface UserAvatarProps {
  displayName: string;
  avatarUrl?: string | null;
  userId: string;
  size?: number;
  sx?: SxProps<Theme>;
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

function getAvatarColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = ((hash % 360) + 360) % 360;
  return `hsl(${hue}, 55%, 50%)`;
}

export function UserAvatar({
  displayName,
  avatarUrl,
  userId,
  size = 32,
  sx
}: UserAvatarProps) {
  const [imgFailed, setImgFailed] = useState(false);

  const initials = getInitials(displayName);
  const bgColor = getAvatarColor(userId);
  const imgSrc = avatarUrl && !imgFailed ? avatarUrl : undefined;

  return (
    <Avatar
      src={imgSrc}
      slotProps={{
        img: {
          onError: () => setImgFailed(true),
          referrerPolicy: "no-referrer"
        }
      }}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.44,
        fontWeight: 600,
        bgcolor: imgSrc ? "transparent" : bgColor,
        ...sx
      }}
    >
      {initials}
    </Avatar>
  );
}
